import React from "react";
import { Collapse, Navbar, NavbarToggler, Nav, NavItem } from "reactstrap";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link } from "react-router-dom";
import AppRoutes from "../../AppRoutes";
import logo from "../../images/logo.png";
import { goTo } from "../../actions/appActions";
import "./header.scss";

class Header extends React.Component {
    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.state = {
            isOpen: false
        };
    }
    toggle() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }

    goHome = () => {
        this.props.goTo("/");
    };
    render() {
        const { curr } = this.props;
        const isHome = curr === "home";
        const isProducts = curr === "products";
        const isGps = curr === "gps";

        const activeStyles = {
            borderBottom: "5px solid #106bad"
        };

        const inActiveStyles = {};
        return (
            <Navbar id="homeHeader" color="light" light={true} expand="md">
                <Link to={AppRoutes.home} className="navbar-brand">
                    <img
                        src={logo}
                        alt="Osrit"
                        style={{
                            height: 30,
                            marginLeft: 5
                        }}
                    />
                </Link>
                <NavbarToggler onClick={this.toggle} />
                <Collapse isOpen={this.state.isOpen} navbar={true}>
                    <Nav className="ml-auto" navbar={true}>
                        <NavItem >
                            <Link
                                style={isHome ? activeStyles : inActiveStyles}
                                to={AppRoutes.home}
                                className="home_header_link text-uppercase"
                            >
                                {"Home"}
                            </Link>
                        </NavItem>
                        <NavItem                        >
                            <Link
                                style={isProducts ? activeStyles : inActiveStyles}
                                to={AppRoutes.products}
                                className="home_header_link text-uppercase"
                            >
                                {"Products"}
                            </Link>
                        </NavItem>
                        <NavItem>
                            <a href="https://www.osrit.com/pricing"
                                rel="noopener noreferrer"
                                className="home_header_link text-uppercase">{'Pricing'}</a>
                        </NavItem>
                        <NavItem >
                            <Link
                                style={isGps ? activeStyles : inActiveStyles} to={AppRoutes.gps}
                                className="home_header_link text-uppercase"
                            >
                                {"Gps"}
                            </Link>
                        </NavItem>
                        <NavItem>
                            {/* <a href={"//" + AppRoutes.blog} */}
                            <a href="https://blog.osrit.com/dashcam"
                                rel="noopener noreferrer"
                                className="home_header_link text-uppercase">{'Blogs'}</a>
                        </NavItem>
                        <NavItem>
                            <a
                                href={AppRoutes.login}
                                className="home_header_link text-uppercase active"
                            >
                                {"Log In"}
                            </a>
                        </NavItem>
                    </Nav>
                </Collapse>
            </Navbar>
        );
    }
}

const mapStateToProps = state => ({});
const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            goTo
        },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Header);
